module.exports = __webpack_public_path__ + "static/Dolce-Latte-2f30deb107166b6af893f9bcc995a09d.png";